import React from 'react';
import { Typography, TypographyProps, SxProps, Theme } from '@mui/material';

interface TruncatedTypographyProps extends TypographyProps {
  text: string | number | undefined;
  lines?: number;
  height?: string | number;
  isHtml?: boolean;
  sx?: SxProps<Theme>;
}

const TruncatedTypography: React.FC<TruncatedTypographyProps> = ({
  text,
  variant = 'body2',
  lines = 1,
  height = 20,
  isHtml = false,
  sx = {},
  ...rest
}) => {
  const truncationStyles: SxProps<Theme> = {
    height,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical' as const,
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  };

  const combinedSx: SxProps<Theme> = Array.isArray(sx)
    ? [truncationStyles, ...sx]
    : { ...truncationStyles, ...sx };

  return isHtml && typeof text === 'string' ? (
    <Typography
      variant={variant}
      {...rest}
      sx={combinedSx}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  ) : (
    <Typography variant={variant} {...rest} sx={combinedSx}>
      {text}
    </Typography>
  );
};

export { TruncatedTypography };
